import * as t from './action_types';
import { makeActionCreatorObjParam } from '@trumedianetworks/tmn-core-components/src/util/redux-helpers';

export const setRoute = makeActionCreatorObjParam(t.SET_ROUTE, 'name', 'data');
